var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-alert',{staticClass:"text-center",attrs:{"color":"success","dark":"","dismissible":""},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_vm._v(" "+_vm._s(_vm.$t('general.turningOn', { name: _vm.name, time: _vm.time }))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }